"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const menu_1 = require("@kyruus/menu");
const ArrowDown_1 = __importDefault(require("@kyruus/react-ikons/ArrowDown"));
/**
 * Renders a radio item for the time of day selection menu
 * @param {Object} props - Component props
 * @param {Object} props.item - The time option item
 * @param {string} props.item.value - The value of the time option
 * @param {string} props.item.label - The display label for the time option
 * @param {string} props.selectedValue - Currently selected time value
 * @returns {React.ReactElement} A radio button item
 */
const RenderItem = ({ item, selectedValue }) => {
    return (react_1.default.createElement(styles_1.StyledRadio, { options: [item], selected: selectedValue, onChange: () => { }, name: `time-of-day-${item.value}` }));
};
RenderItem.propTypes = {
    item: prop_types_1.default.shape({
        value: prop_types_1.default.string.isRequired,
        label: prop_types_1.default.string.isRequired
    }).isRequired,
    selectedValue: prop_types_1.default.string
};
/**
 * A dropdown component that allows users to select a time of day preference
 * @param {Object} props - Component props
 * @param {string} [props.value='anytime'] - Currently selected time value ('anytime', 'am', or 'pm')
 * @param {Function} props.onChange - Callback function triggered when selection changes
 * @param {Object} props.intl - Internationalization object from react-intl
 * @param {Function} props.intl.formatMessage - Function to format internationalized messages
 * @returns {React.ReactElement} A time of day selection dropdown
 */
const TimeOfDay = ({ value, onChange, intl }) => {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const buttonRef = react_1.default.useRef(null);
    const label = intl.formatMessage(messages_1.default['timeOfDay.label']);
    const options = (0, react_1.useMemo)(() => [
        {
            value: 'ANYTIME',
            label: intl.formatMessage(messages_1.default['timeOfDay.anytime'])
        },
        { value: 'AM', label: intl.formatMessage(messages_1.default['timeOfDay.am']) },
        { value: 'PM', label: intl.formatMessage(messages_1.default['timeOfDay.pm']) }
    ], [intl]);
    const selectedItem = options.find((opt) => opt.value === value) || options[0];
    const getDisplayValue = () => {
        const selectedOption = options.find((opt) => opt.value === value) || options[0];
        const messageKey = selectedOption.value === 'ANYTIME'
            ? 'anytime'
            : selectedOption.value.toLowerCase();
        return intl.formatMessage(messages_1.default[`timeOfDay.${messageKey}`]);
    };
    const onMenuOpen = (event) => {
        var _a;
        setAnchorEl(event.currentTarget);
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return (react_1.default.createElement(styles_1.TimeOfDayContainer, { "data-testid": "time-of-day" },
        react_1.default.createElement(styles_1.StyledLabel, { id: "time-of-day-label", htmlFor: "time-of-day-btn" }, label),
        react_1.default.createElement(styles_1.StyledButton, { type: "button", ref: buttonRef, id: "time-of-day-btn", mode: "secondary", onClick: onMenuOpen, "aria-label": intl.formatMessage(messages_1.default.ariaFilterByTimeOfDay), "aria-expanded": Boolean(anchorEl), "aria-haspopup": "menu", "aria-controls": "time-of-day-menu" },
            getDisplayValue(),
            react_1.default.createElement(styles_1.ArrowDown, null,
                react_1.default.createElement(ArrowDown_1.default, null))),
        react_1.default.createElement(styles_1.StyledMenu, { keepMounted: true, id: "time-of-day-menu", anchorEl: anchorEl, open: Boolean(anchorEl), onClose: () => setAnchorEl(null), getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' } }, options.map((option) => (react_1.default.createElement(menu_1.MenuItem, { key: option.value, onClick: () => {
                onChange(option.value);
                setAnchorEl(null);
            }, disableRipple: true, role: "menuitemradio", "aria-checked": option.value === selectedItem.value, "aria-label": option.label },
            react_1.default.createElement(RenderItem, { item: option, selectedValue: selectedItem.value })))))));
};
TimeOfDay.propTypes = {
    value: prop_types_1.default.string,
    onChange: prop_types_1.default.func.isRequired,
    intl: prop_types_1.default.shape({
        formatMessage: prop_types_1.default.func.isRequired
    }).isRequired
};
TimeOfDay.defaultProps = {
    value: 'ANYTIME'
};
exports.default = (0, intl_1.injectIntl)(TimeOfDay);
//# sourceMappingURL=TimeOfDay.js.map